export default {
  "name": "NCDragHeightCom",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCDragHeightCom",
  "label": "上下分栏",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "defTopHeight": {
        "title": "defLeftWid",
        "description": "左侧宽度",
        "type": "string",
        "default": "150px"
      },
      "topMinHeight": {
        "title": "leftMinWid",
        "description": "左侧最小宽度",
        "type": "string",
        "default": "50px"
      },
      "topDom": {
        "title": "leftDom",
        "description": "左侧栏目",
        "type": "node"
      },
      "bottomDom": {
        "title": "rightDom",
        "description": "右侧栏目",
        "type": "node"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": [
    "topDom",
    "bottomDom"
  ]
}